import type { TOC } from '@ember/component/template-only';
import { isEmpty } from '@ember/utils';
import { or } from 'ember-truth-helpers';

interface CircleCharacterSignature {
  Args: {
    character?: string | null;
    fillColor?: string | null;
    number?: number | null;
  };
}

export default <template>
  <svg style="font-variant: lining-nums;" width="18" height="18" viewBox="0 0 18 18">
    <g fill="none" fill-rule="evenodd">
      <circle cx="9" cy="9" r="9" fill={{or @fillColor "#282c36"}}></circle>
      <text fill="#FFF" font-family="CeraPRO-Bold, Cera PRO" font-size="11">
        {{#if (isEmpty @character)}}
          <tspan data-test-number x="6.3" y="12.8">{{@number}}</tspan>
        {{else}}
          <tspan data-test-character x="5.2" y="12.5">{{@character}}</tspan>
        {{/if}}
      </text>
    </g>
  </svg>
</template> satisfies TOC<CircleCharacterSignature>;
